import React from 'react';
import { makeStyles, Box } from '@material-ui/core';

import ErrorIcon from '#web-components/components/Icons/ErrorIcon';
import { FormControlError } from '#web-components/types/formControls';

import styles from './FieldError.styles';

const useStyles = makeStyles(styles, { name: 'Input' });

export type FieldErrorProps = {
  error: FormControlError;
};

export default function FieldError({
  error,
}: FieldErrorProps) {
  const classes = useStyles();

  return (
    <Box component="span" className={classes.errorBox}>
      <ErrorIcon />
      <Box component="span" className={classes.textError}>{error.message}</Box>
    </Box>
  );
}
